/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { mapDependencies } from './dependenciesMap.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { varianceDependencies } from './dependenciesVariance.generated.js';
import { createStdTransform } from '../../factoriesAny.js';
export var stdTransformDependencies = {
  mapDependencies,
  sqrtDependencies,
  typedDependencies,
  varianceDependencies,
  createStdTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesStdTransform.generated.js
// module id = eEoR
// module chunks = 3